<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :options="{ itemsPerPage: 10 }"
              :page="currentPage"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
              locale="ru-RU"
              @pagination="getPagination"
              @click:row="getRow"
            >
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <autocomplete
                          ref="autocomplete"

                          :get-result-value="getResultValue"
                          :search="search"
                          @submit="onSubmit"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.availability="{item}">
                <v-checkbox
                  v-model="item.availability"
                />
              </template>
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import WebApi from "@/views/loyalty/shared/modules/web_api"
import { ParticipantService } from "@/views/loyalty/shared/services/participant_service"
import { getObjectsForSearching, getSearchedObjects } from "@/views/loyalty/shared/modules/utilities"
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { JustpayUser } from "@/views/loyalty/shared/services/justpay-user-service"

export default {
  name: "ParticipantList",
  components: { Autocomplete },
  props: {
    campaignId: {
      type: Number,
      default: 0
    },
    role: {
      type: Number
    }
  },
  data: () => ({
    campaign: {},
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    currentPage: 2,
    loading: false,
    headers: [
      // {
      //   text: "ID",
      //   value: "userId"
      // },
      {
        text: 'Телефон',
        value: 'phone',
      },
      {
        text: "Фамилия",
        value: "surname"
      },
      {
        text: 'Имя',
        value: 'name',
      },
      {
        text: 'Отечество',
        value: 'patronymic',
      },
      {
        text: "Баланс счёта",
        value: "amount"
      },
      {
        text: "Доступность",
        value: 'availability',
      }
    ],
    pageStart: 1,
    pageStop: 2,
    items: [],
    justpayUserService: null,
  }),
  beforeMount () {
    this.webApi = new WebApi(this.$store)
    this.justpayUserService = new JustpayUser()
  },
  async mounted () {
    // const role = +this.$store.state.roles
    this.campaign = localStock.getItem('campaign')
    console.log('this.campaign', this.campaign)
    await this.getItems()
      },
  methods: {
    async getItems () {
      // try {
        this.loading = true
        const users = await this.justpayUserService.getUsersByCustomerId(this.campaign.customerId)
        console.log('users', users)
      if (users) {
          const participantService = new ParticipantService()
          this.items = users.map(m => {
            participantService.add_data(m)
            // console.log('servicePointService.item', servicePointService.item)
            return participantService.item
          })
          this.items.map(async m => {
            // console.log('the.items', m)
            const data_account = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}account/participant/${m.userId}`)
            // console.log('data_account', data_account)
            if (data_account.status_code === 200) {
              const participant_data = data_account.find(f => f.campaign.campaignId === this.campaign.campaignId)
              // console.log('participant_data', participant_data)
              if (participant_data !== undefined) {
                m.amount = participant_data.account.Amount
              }
            }
          })
          const data = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/participant/`)
          // console.log('data', data)
          this.items = this.items.map(m => {
            const participant = data.find(f => f.userId === m.userId && f.campaignId === this.campaign.campaignId)
            if (participant !== undefined ? participant.availability : false) {
              m.availability = participant.availability
            }
            return m
          })
        }
        this.loading = false
    },
    getPagination (item) {
      console.log(`pagination=${JSON.stringify(item)}`)
      this.pageStart = item.pageStart
      this.pageStop = item.pageStop
    },
    getResultValue (result) {
      return result.searched
    },
    getRow (point) {
      console.log('getRow point', point)
      console.log('getRow this.campaign', this.campaign)
      this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/participant/${this.campaign.campaignId}/${point.userId}/${point.availability}`)
    },
    onSubmit (result) {
      const searching = result.searched ? result.searched : result
      console.log('searching.length', searching.length)
      if (searching.length !== 0) {
        this.items = getObjectsForSearching(this.items, searching)
      } else {
        this.pageStop = -1
        this.getItems()
      }
    },
    search (input) {
      console.log('search', input)
      if (input.length < 1) { return [] }
      const arr = getSearchedObjects(this.items, input)
      console.log('arr', arr)
      return arr
    },
  }
}
</script>

<style scoped></style>
